import { Component, Host, HostBinding, Input, OnInit, Optional } from '@angular/core'
import { FormGroup, FormGroupDirective } from '@angular/forms'
import { ThemePalette } from '@angular/material/core'

@Component({
  selector: 'lin-form-submit-button',
  template: `
    <button
      class="submit-button"
      mat-raised-button
      type="submit"
      [color]="color"
      [disabled]="form?.pristine || form?.invalid || isLoading || isDisabled"
      fxLayoutAlign="center center"
    >
      @if (isLoading) {
        <mat-progress-spinner diameter="26" strokeWidth="2" mode="indeterminate" color="accent"></mat-progress-spinner>
      } @else {
        <ng-content></ng-content>
      }
    </button>
  `,
  styles: [
    `
      .submit-button {
        min-width: 130px;
        min-height: 36px;
        color: #fff;
      }
    `,
  ],
  standalone: false,
})
export class FormSubmitButtonComponent implements OnInit {
  @HostBinding('class.linxio-form-submit-button') buttonClass = true
  @Input() color: ThemePalette = 'accent'
  @Input() isLoading = false
  @Input() isDisabled = false

  form: FormGroup

  constructor(@Host() @Optional() private formDirective: FormGroupDirective) {}

  ngOnInit() {
    this.form = this.formDirective && this.formDirective.form
  }
}
